/**
 * Espelho de exibição do catálogo em server/utils/justiceSphere.ts.
 * Prefixos e rótulos precisam permanecer iguais ao catálogo do servidor.
 */
export const JUSTICE_SPHERES = [
  {
    id: 'comum',
    label: 'Justiça Comum',
    shortLabel: 'Comum',
    filterLabel: 'Justiça Comum (Estadual)',
    tribunalPrefixes: ['TJ'],
    superiorTribunalPrefixes: [],
  },
  {
    id: 'trabalho',
    label: 'Justiça do Trabalho',
    shortLabel: 'Trabalho',
    filterLabel: 'Justiça do Trabalho',
    tribunalPrefixes: ['TRT'],
    superiorTribunalPrefixes: [],
  },
  {
    id: 'federal',
    label: 'Justiça Federal',
    shortLabel: 'Federal',
    filterLabel: 'Justiça Federal',
    tribunalPrefixes: ['TRF'],
    superiorTribunalPrefixes: ['STF', 'STJ'],
  },
];

export function justiceSphereById(id) {
  return JUSTICE_SPHERES.find((sphere) => sphere.id === id) || null;
}

export function justiceSphereOptions(labelKey = 'label') {
  return JUSTICE_SPHERES.map((sphere) => ({
    value: sphere.id,
    label: sphere[labelKey] || sphere.label,
  }));
}

export function justiceSphereLabel(id, labelKey = 'label') {
  const sphere = justiceSphereById(id);
  if (!sphere) return id || '';
  return sphere[labelKey] || sphere.label;
}

export function matchTribunalJusticeSphere(sigla, options = {}) {
  const normalized = String(sigla || '').replace(/\s+/g, '').trim().toUpperCase();
  if (!normalized) return null;

  const includeSuperiorCourts = options.includeSuperiorCourts === true;
  let matched = null;

  for (const sphere of JUSTICE_SPHERES) {
    const prefixes = includeSuperiorCourts
      ? [...sphere.tribunalPrefixes, ...sphere.superiorTribunalPrefixes]
      : sphere.tribunalPrefixes;

    for (const prefix of prefixes) {
      if (!normalized.startsWith(prefix)) continue;
      if (!matched || prefix.length > matched.prefixLength) {
        matched = { id: sphere.id, prefixLength: prefix.length };
      }
    }
  }

  return matched?.id ?? null;
}

export function tribunalMatchesJusticeSphere(sigla, justiceType) {
  if (!justiceType) return true;
  return matchTribunalJusticeSphere(sigla, { includeSuperiorCourts: true }) === justiceType;
}
